import { sanitizeRichText, type HealthTheme } from '@hue/contracts';
import { StatusPill } from '@hue/design-system';
import type { ReactNode } from 'react';
import { cn } from './helpers.js';

export function ThemeTag({ theme }: { theme: Pick<HealthTheme, 'displayName' | 'color'> }) {
  return <StatusPill tone={theme.color}>{theme.displayName}</StatusPill>;
}

/// Texto formatado já gravado. Saneia de novo antes de desenhar: a lista fechada é a mesma do
/// servidor, e a segunda passada é defesa contra dado que tenha chegado ao banco por outro caminho.
export function RichText({ html, className }: { html: string; className?: string }) {
  return (
    <div
      className={cn('hue-rich-text text-sm leading-6', className)}
      dangerouslySetInnerHTML={{ __html: sanitizeRichText(html) }}
    />
  );
}

/// A etiqueta é do design system; fica exportada daqui para as telas do módulo.
export { Chip } from '@hue/design-system';

export function Notice({ tone, children }: { tone: 'info' | 'warning'; children: ReactNode }) {
  return (
    <div
      className={cn(
        'rounded-xl border px-4 py-3 text-sm leading-6',
        tone === 'info' && 'border-info/35 bg-info/10',
        tone === 'warning' && 'border-warning/40 bg-warning/10',
      )}
    >
      {children}
    </div>
  );
}

/// A chave liga/desliga é do design system; o módulo a conhece pelo nome de sempre.
export { Switch as Toggle } from '@hue/design-system';
